module.exports = __webpack_public_path__ + "resources/img/img-danbiAi-en.9614dfe2a6985e9dffe41eb0efe41798.png";